export default function Kontakt(props) {
	return (
		<span id="a11y-kontakt">
			<strong>{props.children}</strong>
		</span>
	);
}
